<span id="latex-rendering-{{uuid}}" class="latex"
[ngClass]="{'disabled': disable}"></span>
@if (!displayForSummary || !displaySolution) {
  <div id="latex-keyboard-{{uuid}}"></div>
}
